"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NavigationProvider = exports.NavigationContext = void 0;
var React = require("react");
exports.NavigationContext = React.createContext({});
/**
 * Create a React context to handle the navigation item and scroll to corresponding section
 * The react context holds a global key/value store the map each navigation button to a react ref
 */
var NavigationProvider = function (_a) {
    var children = _a.children;
    return React.createElement(exports.NavigationContext.Provider, { value: {} }, children);
};
exports.NavigationProvider = NavigationProvider;
//# sourceMappingURL=NavigationContext.js.map